<template>
  <transition name="fade" mode="out-in" appear>

    <div id="Site" v-if="isLoaded">
      <transition name="fade" mode="out-in" appear>
        
        <div id="SiteContainer" class="SiteContainer SiteContainer_quiz" v-if="user && $route.name == 'qualiscore'" key="quiz">

          <transition name="header" appear>
            <HeaderQuiz />
          </transition>
          <main role="main" class="Main">
            <transition name="fade" appear>
              <QuizBackground ref="background"/>
            </transition>
            <transition name="fade" mode="out-in" appear>
              <router-view />
            </transition>
          </main>
        </div>
        
        <div id="SiteContainer" class="SiteContainer" v-else-if="user && user.token" key="pages">

          <Header />

          <main role="main" class="Main">
            <transition name="fade" mode="out-in" appear>
              <router-view @openPanel="onOpenPanel" />
            </transition>

            <PanelAdvice :datas="panel.datas" v-if="panel && panel.type == 'advice'" :key="panel.datas.slug" @closePanel="panel = null" />
            <PanelEmail v-if="panel && panel.type == 'email'" @closePanel="panel = null" />
            <PanelQualiscore v-if="panel && panel.type == 'qualiscore'" @closePanel="panel = null" />
            
            <transition name="fade" appear>
              <PopinVideo v-if="panel && panel.type == 'video'" @closePanel="panel = null" :data="panel.data" />
            </transition>
          </main>
        </div>
      </transition>

      <!-- <Cookies ref="cookies" /> -->
    
    </div>

    <div id="Site" v-else>
      
      <div class="Page">
        <section class="Section Section_full">
          <div class="Section_wrapper">
            <h3>chargement</h3>
            <div class="Loader"></div>
          </div>
        </section>
      </div>
    
    </div>

  </transition>

</template>

<script>
import vhCheck from 'vh-check'

import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

import { TweenMax, ScrollToPlugin } from 'gsap/all'
import { mapActions, mapState } from 'vuex' 

import HeaderQuiz from '@/components/partials/HeaderQuiz'
import Header from '@/components/partials/Header'
import QuizBackground from '@/components/partials/QuizBackground'
import Cookies from '@/components/partials/Cookies'

import PanelAdvice from '@/components/sections/PanelAdvice'
import PanelEmail from '@/components/sections/PanelEmail'
import PanelQualiscore from '@/components/sections/PanelQualiscore'
import PopinVideo from '@/components/sections/PopinVideo'

export default {
  name: 'App',
  components: {
    HeaderQuiz,
    Header,
    QuizBackground,
    Cookies,
    PanelAdvice,
    PanelEmail,
    NprogressContainer,
    PanelQualiscore,
    PopinVideo
  },
  data() {
    return {
      isLandscape: false,
      loadCount: 0,
      images: [],
      panel: null
    }
  },
  computed: {
    ...mapState([
      'user',
      'isLoaded'
    ])
  },
  watch: {
    isLoaded()
    {
      if(this.isLoaded)
      {
        document.body.style.cursor  = 'inherit'
      }else{
        document.body.style.cursor = "wait"
      }
    }
  },
  methods: {
    ...mapActions([
      'setUser',
      'setMousePosition',
      'setScrollTop'
    ]),
    onOpenPanel(panel)
    {
      console.log('onOpenPanel', panel)
      this.panel = panel
    },
    onResize(){
      this.$nextTick( () => {

        vhCheck({
          cssVarName: 'vh',
          force: true
        });
        
        var orientation = window.orientation
        if (this.$tools.isMobile() && Math.abs(orientation) === 90) {
          this.isLandscape = true
        } else {
          this.isLandscape = false
        }
      })
    },
    registerUser()
    {
      if(this.$cookies.isKey("user_session"))
      {
        var token = this.$cookies.get("user_session")

        console.log('Get userSession : ', token)
        this.$api.getUser(token)
        .then(response => {
          console.log('setUser', response.data.participant)
          this.setUser(response.data.participant)
        })
      }
      else{
        this.$api.registerUser()
        .then(response => {
          console.log('Set userSession : ', response.data.data.token)
          this.$cookies.set("user_session", response.data.data.token, "3y")
          this.setUser({ token: this.$cookies.get("user_session") })
        })
      }
    }
  },
  created()
  {
    document.body.style.cursor = "wait"
    console.log(this.user)
    // this.registerUser()
  },
  mounted()
  {
    // this.$raf.init()

    window.addEventListener('resize', this.onResize)
    window.addEventListener('orientationchange', this.onResize)
    this.onResize()

    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS')
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
    var isIE = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)
    var isEdge = navigator.userAgent.indexOf('Edge') > 0

    if (isSafari) { document.body.classList.add('safari') }
    if (isFirefox) { document.body.classList.add('firefox') }
    if (isIE) { document.body.classList.add('ie'); this.isOldNavigator = true; }
    if (isEdge) { document.body.classList.add('edge') }

    window.addEventListener('scroll', (e) => {
      const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop)
      this.setScrollTop(scrollTop)
    })

    if (this.$tools.isTouchDevice()) {
      window.addEventListener('devicemotion', (e) => {
        const accel = e.accelerationIncludingGravity
        this.setMousePosition({x: accel.x * 200, y: accel.y * 200})
      })
    }
    else {
      window.addEventListener('mousemove', (e) => {
        this.setMousePosition({x: e.clientX, y: e.clientY})
      })
    }

    // ACTIVE SCROLL
    this.$raf.init()
    this.$scroll.active()
  }
}
</script>

<style lang="stylus">

@import './styles/variables'

@import './styles/settings'
@import './styles/global'
@import './styles/animations'

@import './styles/tarteaucitron'

// GENERIC
global-reset()
reset-html5()

html.nprogress-busy

  cursor wait

#nprogress 
  
  .bar 
    background: $red!important

    position: fixed;
    z-index: 1031;
    top: 0;
    left: 0;

    width: 100%;
    height: 4px!important;

  .peg

    box-shadow: none!important

  .spinner-icon

    border-top-color: $red!important;
    border-left-color: $red!important;
    display none!important

    @media $medium

      display none!important

    
</style>
